import { ColorOptions, required } from '@jfs/ui-new'
import { TextInputNew } from '../../components/AdminInputs'
import { Dropdown } from '../../components/Dropdown'
import { TextInputWithCb } from '../../components/TextInputWithCb'
import { WrapperText } from '../../components/WrapperText'
import { getSchemaData } from '../../utils/constants'

const typeData = [
  { id: 1, value: 'Rule Package Type' },
  { id: 2, value: 'Request Type' },
  { id: 3, value: 'Card Scheme' },
  { id: 4, value: 'Card Type' },
  { id: 4, value: 'Banking Code Type' },
  { id: 4, value: 'Transaction Type' },
  { id: 4, value: 'Instrument Type' },
]
const statusData = [
  { id: 1, value: 'Activate' },
  { id: 2, value: 'Deactivate' },
]

const textinputStyle = {
  type: 'body14',
  borderColor: '#d1d3e2' as ColorOptions,
  labelPaddingBottom: 8,
  borderRadius: 4,
  labelFontFamily: 'jiotype-bold',
  fontFamily: 'jiotype-medium',
  labelColor: '#6e707e' as ColorOptions,
  labelFontSize: 12,
  fontSize: 14,
  selectionColor: 'BLUE',
  paddingHorizontal: 8,
  color: 'BLACK_21' as ColorOptions,
  paddingVertical: 8,
  focusBorderColor: '#d1d3e2' as ColorOptions,
  borderWidth: 2,
  onFocusBorderWidth: 2,
}

export const formData: any = (
  addCode: (data: any) => void,
  updateCode: (data: any) => void,
  message: string,
  id: any,
  typeArray?: any,
) => {
  return id
    ? [
        {
          key: 'updateCode',
          formItems: [
            {
              horizontalComps: [
                {
                  fieldName: 'code',
                  ComponentName: TextInputWithCb,
                  placeholder: 'Code',
                  label: 'Code',
                  validationSchema: required,
                },
                {
                  fieldName: 'name',
                  ComponentName: TextInputNew,
                  placeholder: 'Name',
                  label: 'Name',
                  validationSchema: required,
                  ...textinputStyle,
                },
                {
                  fieldName: 'type',
                  ComponentName: TextInputWithCb,
                  label: 'Type',
                  title: 'Type',
                },
                {
                  fieldName: 'status',
                  ComponentName: Dropdown,
                  minWidth: 140,
                  title: 'Status',
                  label: 'Status*',
                  validationSchema: required,
                  data: statusData,
                },
              ],
            },
            {
              horizontalComps: [
                {
                  fieldName: 'extraField1',
                  ComponentName: TextInputNew,
                  placeholder: 'Extra Field 1',
                  label: 'Extra Field 1',
                  ...textinputStyle,
                },
                {
                  fieldName: 'extraField2',
                  ComponentName: TextInputNew,
                  placeholder: 'Extra Field 2',
                  label: 'Extra Field 2',
                  ...textinputStyle,
                },
              ],
            },
            {
              fieldName: 'description',
              ComponentName: TextInputNew,
              placeholder: 'Description',
              label: 'Description',
              ...textinputStyle,
            },
            {
              fieldName: 'message',
              ComponentName: WrapperText,
              title: message,
              color: 'ERROR',
              hide: message === '',
            },
          ],
          horizontalFlex: 1,
          onSubmit: async (values: any) => {
            updateCode(values)
            return 'end'
          },
          actionTitle: 'Update',
        },
      ]
    : [
        {
          key: 'addCode',
          formItems: [
            {
              horizontalComps: [
                {
                  fieldName: 'code',
                  ComponentName: TextInputNew,
                  placeholder: 'Code',
                  label: 'Code*',
                  validationSchema: required,
                  ...textinputStyle,
                },
                {
                  fieldName: 'name',
                  ComponentName: TextInputNew,
                  placeholder: 'Name',
                  label: 'Name*',
                  validationSchema: required,
                  ...textinputStyle,
                },
                {
                  fieldName: 'type',
                  ComponentName: Dropdown,
                  minWidth: 140,
                  label: 'Type*',
                  title: 'Type',
                  validationSchema: required,
                  data: getSchemaData(typeArray, 'sysControlConfig') ?? typeData,
                },
                {
                  fieldName: 'status',
                  ComponentName: Dropdown,
                  minWidth: 140,
                  title: 'Status',
                  label: 'Status*',
                  validationSchema: required,
                  data: statusData,
                },
              ],
            },
            {
              horizontalComps: [
                {
                  fieldName: 'extraField1',
                  ComponentName: TextInputNew,
                  placeholder: 'Extra Field 1',
                  label: 'Extra Field 1',
                  ...textinputStyle,
                },
                {
                  fieldName: 'extraField2',
                  ComponentName: TextInputNew,
                  placeholder: 'Extra Field 2',
                  label: 'Extra Field 2',
                  ...textinputStyle,
                },
              ],
            },
            {
              fieldName: 'description',
              ComponentName: TextInputNew,
              placeholder: 'Description',
              label: 'Description',
              ...textinputStyle,
            },
            {
              fieldName: 'message',
              ComponentName: WrapperText,
              title: message,
              color: 'ERROR',
              hide: message === '',
            },
          ],
          horizontalFlex: 1,
          onSubmit: async (values: any) => {
            addCode(values)
            return 'end'
          },
          actionTitle: 'Add Mapping',
        },
      ]
}
